import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form, Button, Input } from "reactstrap";
import FooterLink from "../Footer/Footer_link";

// Import Logo
import LogoDark from "../../assets/images/webora-light.svg";
import logolight from "../../assets/images/webora-dark.svg";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      links: [
        {
          id: 1,
          title: "Services",
          child: [
            { title: "Web Development", link: "#" },
            { title: "App Development", link: "#" },
            { title: "Digital Marketing", link: "#" },
            { title: "SEO Services", link: "#" },
          ],
        },
        {
          id: 2,
          title: "Company",
          child: [
            { title: "About Us", link: "#" },
            { title: "Our Team", link: "#" },
            { title: "Contact Us", link: "#" }
          ],
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        {/* Footer Start */}
        <footer className="section bg-light bg-footer pb-5">
          <Container>
            <Row>
              <Col lg={4}>
                <div className="footer-info mt-4">
                  <img src={LogoDark} alt="Webora Logo" height="22" />
                  <p className="text-muted mt-4 mb-2">
                    Webora is dedicated to delivering high-quality IT and digital marketing solutions, empowering businesses to grow and thrive in the digital world.
                  </p>
                  <div className="team-social mt-4 pt-2">
                    <ul className="list-inline mb-0">
                      <li className="list-inline-item">
                        <Link to="#" className="text-reset"><i className="mdi mdi-facebook"></i></Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to="#" className="text-reset"><i className="mdi mdi-twitter"></i></Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to="#" className="text-reset"><i className="mdi mdi-linkedin"></i></Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to="#" className="text-reset"><i className="mdi mdi-instagram"></i></Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <Row className="pl-0 md-lg-5">
                  {/* Render Footer Links */}
                  {this.state.links.map((item, key) => (
                    <Col lg={6} key={key}>
                      <div className="mt-4">
                        <h5 className="f-20">{item.title}</h5>
                        <ul className="list-unstyled footer-link mt-3">
                          {item.child.map((linkItem, key) => (
                            <li key={key}>
                              <Link to={linkItem.link}>
                                {linkItem.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Col>
              <Col lg={4}>
                <div className="mt-4">
                  <h5 className="f-20">Stay Updated</h5>
                  <p className="text-muted">Subscribe to our newsletter for the latest updates and offers.</p>
                  <div className="subscribe mt-4 pt-1">
                    <Form action="#">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Input placeholder="Your Email Address" type="email" style={{ height: 'auto', flex: '1' }} />
                        <Button color="primary" className="ml-2" style={{ padding: '10px 20px', borderRadius: '25px' }}>
                          <i className="mdi mdi-send"></i>
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </Col>
            </Row>
            <hr className="my-5" />
            {/* Render Footer Link End */}
            <FooterLink />
          </Container>
        </footer>
        {/* Footer End */}
      </React.Fragment>
    );
  }
}

export default Footer;
